<template>
 <footer>
   <div class="flex">
    <section class="contact">
      <h6>Kontakt</h6>
      <ul>
        <li>
          <i class="material-icons">phone</i>
          <a href="tel:+48713369521">+48 71 336 95 21</a>
        </li>
        <li>
          <i class="material-icons">email</i>
          <a href="mailto:bok@afkcob.pl">bok@afkcob.pl</a>
        </li>
      </ul>
    </section>
    <nav>
      <div>
        <h6>Nawigacja</h6>
        <ul>
          <li><router-link to="/pakiety" title="Pakiety">Pakiety</router-link></li>
          <li><router-link to="/faq" title="Faq">FAQ</router-link></li>
          <li><router-link to="/galeria" title="Galeria">Galeria</router-link></li>
          <li><a :href="panel" title="Panel Klienta">Panel Klienta</a></li>
          <li><router-link to="/kontakt" title="Kontakt">Kontakt</router-link></li>
        </ul>
      </div>
      <div>
        <h6>Istotne informacje</h6>
        <ul>
          <li><a href="./ciasteczka.pdf" target="_blank">Ciasteczka</a></li>
          <li><a href="./polityka_prywatnosci.pdf" target="_blank">Polityka prywatności</a></li>
          <li><a href="./regulamin_15.04.2021.pdf" target="_blank">Regulamin</a></li>
        </ul>
      </div>
      <div style="display: none">
        <h6>Usługi</h6>
        <ul>
          <li><a href="#">Księgowość</a></li>
          <li><a href="#">Kadry i Płace</a></li>
          <li><a href="#">Wirtualne Biuro</a></li>
          <li><a href="#">Marketing</a></li>
          <li><a href="#">Rejestracja firmy</a></li>
          <li><a href="#">Obsługa prawna</a></li>
          <li><a href="#">Neurobiznes</a></li>
          <li><a href="#">Asystent administracyjny</a></li>
        </ul>
      </div>
      <div>
        <h6>Grupa AFK</h6>
        <ul>
          <li><a href="https://www.afk-cob.pl/">AFK Centrum Obsługi Biznesu</a></li>
        </ul>
      </div>
    </nav>
  </div>
  <p class="copyright">&copy; AFK Wirtualne Biuro 2021, Wszelkie prawa zastrzeżone.</p>
 </footer>
</template>

<script>
export default {
  name: 'FooterMain',
  computed:{
    panel() {
      return this.$store.state.panel;
    },
  },
}
</script>

<style scoped lang="scss">
  footer { background: $grayLight; overflow: auto; }
  footer div.flex { display: flex; flex-wrap: wrap; justify-content: space-around; margin: 20px 50px 15px; }
  footer section.contact { padding: 15px 60px;  border-radius: 3px; }
  footer section.contact h6 { margin: 0 0 20px 34px; padding: 0; color: $fontGray; color: #fff; font-weight: 500; font-size: 16px; }
  footer section.contact ul { margin: 0; padding: 0; list-style: none; }
  footer section.contact ul li { display: flex; margin: 10px 0; }
  footer section.contact ul li i.material-icons { display: flex; flex-shrink: 0; justify-content: center; align-items: center; width: 24px; height: 24px;
    margin-right: 10px; color: $fontGray; color: #fff; font-size: 18px; }
  footer section.contact ul li p { margin: 0; padding: 0; color: $fontGray; color: #fff; font-size: 15px; line-height: 24px; }
  footer section.contact ul li a { color: #fff; font-size: 15px; line-height: 24px; text-decoration: none; }
  footer section.contact ul li a:hover { text-decoration: underline; }
  footer nav { display: flex; }
  footer nav div { margin: 0 20px; padding: 15px; }
  footer nav h6 { margin: 0 0 20px 0; padding: 0; color: $fontGray; color: #fff; font-weight: 500; font-size: 16px; }
  footer nav ul { margin: 0; padding: 0; list-style: none; }
  footer nav ul li { margin: 5px 0; }
  footer nav ul li a { color: $fontGray; color: rgba(255, 255, 255, 0.9); text-decoration: none; font-size: 14px; }
  footer nav ul li a:hover { text-decoration: underline; }
  footer p.copyright { margin: 0; padding: 15px; color: $fontBlack; color: #fff; font-weight: 400; font-size: 13px; text-align: center; border-top: 1px solid rgba(255, 255, 255, 0.05); }

  @media (max-width: 1429px) {
    footer section.contact { padding: 15px 10px; }
    footer nav div { margin: 0 10px; }
  }

  @media (max-width: 1350px) {
    footer div.flex { display: none; }
    footer p.copyright { padding: 7.5px; }
  }
</style>
